import { NullTemplateVisitor } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateService } from '../../../shared/services/date.service';
import { ValidatorsService } from '../../../shared/services/validators.service';
import { ExperimentDetailsShowHideService } from '../../services/experiment-details-show-hide.service';

@Injectable()
export class ExperimentDetailsFormBuilderService {

  constructor(
    private formBuilder: FormBuilder, 
    private validatorsService: ValidatorsService, 
    private dateService: DateService,
    private experimentDetailsShowHideService: ExperimentDetailsShowHideService) { }

  public build(): FormGroup {
    return new ExperimentDetailsFormService(this.formBuilder, this.validatorsService, this.dateService, this.experimentDetailsShowHideService).form;
  }
}

class ExperimentDetailsFormService {
  
  private formGroup: FormGroup;

  public get form(): FormGroup {
    return this.formGroup;
  }
  
  constructor(
    private formBuilder: FormBuilder, 
    private validatorsService: ValidatorsService, 
    private dateService: DateService,
    private experimentDetailsShowHideService: ExperimentDetailsShowHideService) {

    this.formGroup = this.formBuilder.group({
      ceSite: [null, [Validators.required]],
      
      crop: [null, [Validators.required]],
      
      requestPurpose: this.formBuilder.control(
        { value: null, disabled: false },
        [Validators.required]
      ),
      
      title: this.formBuilder.control({ value: null, disabled: false }, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(94)
      ]),
      
      description: this.formBuilder.control({ value: null, disabled: false }),
     
      delegate: this.formBuilder.control({ value: null, disabled: false }),

      pmoProgram: [null, [Validators.required]],
      
      pmoProject: [null, [Validators.required]],
      
      productConcept: [null, [Validators.required]],
      
      plantingDate: this.formBuilder.control({ value: null, disabled: false }, [
        Validators.required, 
        this.validatorsService.mustBeOnOrAfterDate(this.dateService.getDateAfterXDays(12)), 
        this.validatorsService.isValidDate
      ]),

      seedPacketDate: this.formBuilder.control({ value: null, disabled: false }, [Validators.required]),

      weeksOfColdTreatment:this.formBuilder.control({ value:0, disabled:false }, [Validators.required, Validators.min(0)]),

      transgenic: this.formBuilder.control({ value: false, disabled: false }, [Validators.required]),

      unapproved: this.formBuilder.control({ value: false, disabled: false }, [Validators.required]),
      
      stewarded: this.formBuilder.control({ value: false, disabled: false }, [Validators.required]),

      ppqRequired: this.formBuilder.control({ value: false, disabled: false }, [Validators.required]),
      
      phytoInspectionRequired: this.formBuilder.control({ value: false, disabled: false }, [Validators.required])
    });

    this.formGroup.get('requestPurpose').valueChanges.subscribe(rp => {
      this.experimentDetailsShowHideService.updateView(this.formGroup, rp);
    });
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-details/experiment-details-form/experiment-details-form-builder.service.ts